import { jsx as _jsx } from "react/jsx-runtime";
import { PageLoading } from '#pplx/frontend/apps/ask/vertical-shared/PageLoading.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import React, { memo } from 'react';
import { Redirect } from 'wouter';
export const ProtectedSettingsPageGate = memo(function ProtectedSettingsPageGate({ state, Authorized, Loading = PageLoading }) {
    switch (state.type) {
        case 'loading':
            return _jsx(Loading, {});
        case 'authorized':
            return _jsx(Authorized, {});
        case 'unauthorized':
            return _jsx(Redirect, { to: state.redirectTo, replace: true });
        default:
            assertUnreachableValue(state);
    }
});
//# sourceMappingURL=ProtectedSettingsPageGate.js.map